import data from "@/content/comparison.json";
import Reveal from "@/components/home/Reveal";
import { Check, X } from "lucide-react";

const isNegative = (v) => /^no\b/i.test(v) || /^la app/i.test(v) || /^depende/i.test(v) || /%/.test(v) || /semanas/.test(v) || /RFC/.test(v) || /360/.test(v);

export const ComparisonTable = ({ rows = data.rows, headers = data.headers, note = data.note }) => (
  <section id="comparativo" className="mt-section bg-brand-cream" data-testid="comparison-section">
    <div className="mt-container">
      <Reveal className="max-w-2xl">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl leading-tight">MenuThere vs. las apps que te cobran comisión</h2>
        <p className="mt-4 text-base md:text-lg text-gray-600">Compara antes de decidir dónde poner tu menú.</p>
      </Reveal>

      <Reveal delay={120} className="mt-10 hidden md:block rounded-3xl bg-white shadow-[0_12px_40px_rgba(255,102,18,0.1)] border border-orange-100 overflow-hidden">
        <table className="cmp-table" data-testid="comparison-table">
          <thead>
            <tr className="bg-brand-cream/70">
              <th className="w-[34%] text-gray-500">{headers[0]}</th>
              <th className="col-mt !bg-brand-green !text-white"><span className="inline-flex items-center gap-2"><img src="/images/menuthere-logo-full-new.svg" alt="" className="h-5 brightness-0 invert" /> {headers[1]}</span></th>
              <th className="text-gray-500">{headers[2]}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(([c, mt, apps]) => (
              <tr key={c}>
                <td className="font-semibold text-brand-carbon">{c}</td>
                <td className="col-mt"><span className="inline-flex items-start gap-2"><Check className="w-4 h-4 mt-0.5 shrink-0" /> {mt}</span></td>
                <td className="col-apps"><span className="inline-flex items-start gap-2">{isNegative(apps) && <X className="w-4 h-4 mt-0.5 shrink-0 text-red-400" />} {apps}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Reveal>

      <div className="mt-8 md:hidden space-y-3" data-testid="comparison-cards-mobile">
        {rows.map(([c, mt, apps], i) => (
          <Reveal key={c} delay={i * 50} className="rounded-2xl bg-white border border-orange-100 p-4 shadow-sm">
            <p className="text-xs uppercase tracking-wider text-gray-500 font-semibold">{c}</p>
            <div className="mt-2 flex items-start gap-2 text-brand-green font-semibold text-sm"><Check className="w-4 h-4 mt-0.5 shrink-0" /><span><span className="text-gray-500 font-normal">MenuThere: </span>{mt}</span></div>
            <div className="mt-1.5 flex items-start gap-2 text-gray-500 text-sm"><X className="w-4 h-4 mt-0.5 shrink-0 text-red-400" /><span><span className="font-normal">Apps: </span>{apps}</span></div>
          </Reveal>
        ))}
      </div>

      <p className="mt-5 text-xs text-gray-500" data-testid="comparison-note">{note}</p>
    </div>
  </section>
);

export default ComparisonTable;
